import * as actionType from './ActionType';

const initialState = {
  filter: {
    from: 0
  },
  list: []
};

export function settlementsReducer(state = initialState, action) {
  switch (action.type) {
    case actionType.SET_SETTLEMENTS_FILTER:
      return {
        ...state,
        filter: action.payload.filter
      };
    case actionType.SET_SETTLEMENTS_LIST:
      return {
        ...state,
        list: action.payload.list
      };
    default:
      return state;
  }
}
